<template>
    <div class="tw:border tw:border-gray-200 tw:rounded-lg tw:p-3 tw:bg-white">
        <div class="tw:flex tw:items-center tw:justify-between tw:gap-3">
            <div class="tw:flex tw:flex-col tw:gap-1 tw:min-w-0">
                <span class="tw:text-xs tw:uppercase tw:tracking-wide tw:text-gray-500">Podcast Configuration</span>
                <span class="tw:text-sm tw:font-medium tw:text-gray-800 tw:truncate">{{ summaryText }}</span>
            </div>
            <e-button
                v-if="!readonly"
                type="is-primary"
                size="is-small"
                outlined
                @click="$emit('configure')"
            >
                Configure
            </e-button>
        </div>
    </div>
</template>

<script>
export default {
    name: 'PodcastConfigurationSummary',

    props: {
        selectedCount: {
            type: Number,
            default: 0,
        },
        readonly: {
            type: Boolean,
            default: false,
        },
    },

    emits: ['configure'],

    computed: {
        summaryText() {
            if (this.selectedCount === 0) {
                return 'No options selected yet.';
            }

            return `${this.selectedCount} options selected`;
        },
    },
};
</script>
